import getRouterBasename from '@/lib/router';
import { rememberAuthReturnTo } from '@/lib/authRedirect';
import { isSharePath, pathWithoutBasename } from '@/lib/share';
import { toast } from 'sonner';

import { ChainlitAPI, ClientError } from '@chainlit/react-client';

// Same-origin always (works for :8000 built UI and :5174+proxy).
const url = window.origin + getRouterBasename();
const serverUrl = new URL(url);

const httpEndpoint = serverUrl.toString();

const on401 = () => {
  // Public share pages must not bounce to login. Share content itself is loaded
  // via plain fetch in SharedThread (with its own 404/error UI); this only
  // covers incidental apiClient 401s (e.g. config) while viewing a share.
  if (isSharePath()) {
    let msg =
      'Ova stranica je samo za pregled. Prijava nije potrebna za podeljene razgovore.';
    try {
      const lang = localStorage.getItem('fongpt-language') || 'sr-RS';
      if (lang.toLowerCase().startsWith('en')) {
        msg =
          'This page is view-only. Sign-in is not required for shared chats.';
      }
    } catch {
      // keep Serbian default
    }
    toast.message(msg);
    return;
  }
  if (window.location.pathname !== getRouterBasename() + '/login') {
    rememberAuthReturnTo(
      `${pathWithoutBasename()}${window.location.search}${window.location.hash}`
    );
    window.location.href = getRouterBasename() + '/login';
  }
};

const onError = (error: ClientError) => {
  toast.error(error.toString());
};

export const apiClient = new ChainlitAPI(
  httpEndpoint,
  'webapp',
  {},
  on401,
  onError
);
